import FormField from "@/components/forms/FormField";

/**
 * A classroom's division, with the campaign's existing divisions offered
 * as suggestions. Classrooms in the same division compete for top
 * classroom prizes.
 */
export default function DivisionField({ value, onChange, error, options = [] }) {
  return (
    <div>
      <FormField
        name="division"
        label="Division"
        placeholder="Division 1"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        maxLength={40}
        list="division-options"
        autoComplete="off"
        note="Classrooms in the same division compete for Top classroom prizes. Leave it blank if your school doesn't use divisions."
      />
      <datalist id="division-options">
        {options.map((option) => <option key={option} value={option} />)}
      </datalist>
    </div>
  );
}
